import { ClickPosition } from '~/utils/click-position';
import { usePageActive } from '~/utils/active/use-page-active';
import { useCallback } from 'react';

export const useActiveToSearch = (query: string): ((position: ClickPosition, id?: string) => void) => {
  const active = usePageActive();

  return useCallback((position, id) => {
    active({
      schemaOption: {
        pageType: 'search',
        query,
      },
      ampExtra: {
        enter_position: position,
        enter_page_click_id: id || null,
      },
    });
  }, []);
};
